import { render, staticRenderFns } from "./companySolution.vue?vue&type=template&id=3131fb9f&scoped=true&"
import script from "./companySolution.vue?vue&type=script&lang=js&"
export * from "./companySolution.vue?vue&type=script&lang=js&"
import style0 from "./companySolution.vue?vue&type=style&index=0&id=3131fb9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3131fb9f",
  null
  
)

export default component.exports